import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import Html from './../Html';
import Container from './../Container';
import css from 'css';

class LargeTitle extends Component {

    constructor() {
        super();

        this.state = {

        }
    }

    render() {
        const { data } = this.props;

        //console.log('LargeTitle:',data);

        return (
            <ModuleWrapper background={data.background}>
                <Container>
                    <Html>{data.title}</Html>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(LargeTitle);

const ModuleWrapper = styled.div`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
    padding: 70px 0;
    @media (max-width: 768px) {
        padding: 30px 0;
    }
    > div > div {
        text-align:left;
        font-size: 43px;
        line-height:50px;
        font-family: ${css.fonts.bg_bold};
        @media (max-width: 768px) {
            font-size: 30px;
            line-height:1.2;
        }
        @media (max-width:480px) {
            font-size: 26px;
            line-height: 31px;
        }
    }
`



// WEBPACK FOOTER //
// ./src/partials/modules/LargeTitle.js